angular.module('iqxCore')
  .controller('TimesheetCtrl', function ($scope, SweetAlert, $routeParams, $http, $window, FormSvc, sendMessageDialogSvc) {
    FormSvc.setOptions($scope, { autoEdit: true })
    $scope.TSID = $routeParams.id
    $scope.showRates = $scope.userHasRight('TSSHOWRATES')

    $scope.fetchTimesheet = function () {
      return $scope.fetch({
        fetchAPI: 'callresult/nettimesheet?pTempTimesheetID=' + $scope.TSID,
        fetchTarget: 'timesheet',
        dateFields: ['weekenddate'],
        momentFields: ['completedat'],
        booleanFields: ['hasScannedImage']
      })
    }

    $scope.fetchQueryType = function () {
      return $scope.fetch({
        fetchAPI: 'callresult/NetTimesheetQueryType',
        fetchTarget: 'queryType'
      })
    }

    $scope.fetchTimesheetShifts = function () {
      return $scope.fetch({
        fetchAPI: 'callresult/nettimesheetshifts?pTempTimesheetID=' + $scope.TSID,
        fetchTarget: 'timesheetShifts',
        multiRow: true,
        dateFields: ['weekenddate', 'shiftdate'],
        timeFields: ['timefrom', 'timeto']
      })
        .then(function () {
          $scope.timesheetShiftsTotal = FormSvc.arrayTotal($scope.timesheetShifts, 'shiftduration')
        })
    }

    $scope.sendMessage = function () {
      return sendMessageDialogSvc.createMessageFromDialog($scope, 'TIMESHEET', 'Query Timesheet ' + $scope.timesheet.serialnumber, { ptimesheetid: $scope.TSID })
        .then(function () {
          FormSvc.alert("Query Sent", "Your query has been sent", "success")
        })
    }

    $scope.fetchTimesheetTimes = function () {
      return $scope.fetch({
        fetchAPI: 'callresult/nettimesheettimes?pTempTimesheetID=' + $scope.TSID,
        fetchTarget: 'timesheetTimes',
        multiRow: true,
        dateFields: ['weekstartdate', 'shiftdate'],
        booleanFields: ['dayticked'],
        timeFields: ['timefrom']
      })
        .then(function () {
          $scope.timesheetTimesTotal = FormSvc.arrayTotal($scope.timesheetTimes, 'hours')
        })
    }

    $scope.checkForRateContent = function () {
      angular.forEach($scope.timesheetRates, function (rt) {
        if (rt.ShiftDate && !rt.IsExpenses) { $scope.rateDates = true }
        if (rt.IsExpenses) { $scope.rateExpenses = true }
      })
    }

    $scope.fetchTimesheetRates = function () {
      return $scope.fetch({
        fetchAPI: 'callresult/nettimesheetrates?pTempTimesheetID=' + $scope.TSID,
        fetchTarget: 'timesheetRates', booleanFields: ['IsExpenses'], multiRow: true
      })
        .then(function () {
          $scope.timesheetRatesTotal = FormSvc.arrayTotal($scope.timesheetRates, 'Total')
          $scope.checkForRateContent()
        })
    }

    $scope.load = function () {
      $scope.timesheet = {}
      $scope.shiftTimesheet = false
      $scope.timeTimesheet = false
      return $scope.fetchTimesheet()
        .then(function () {
          if ($scope.timesheet.timesheettype == 'S') {
            $scope.shiftTimesheet = true
            return $scope.fetchTimesheetShifts()
          } else if ($scope.timesheet.timesheettype == 'T') {
            $scope.timeTimesheet = true
            return $scope.fetchTimesheetTimes()
          }
        })
        .then(function () {
          return $scope.fetchTimesheetRates()
        })
        .then(function () {
          return $scope.fetchQueryType()
        })
    }

    $scope.showImage = function () {
      $http.get('/api/document/doxi', { params: { Type: 'TIMESHEET', 'TimesheetID': $scope.TSID } })
        .then(function (res) {
          $window.open('/api/document/download?doxi=' + res.data, '_blank')
        })
    }

    $scope.sendTimesheetQueryForm = function () {
      return $scope.fetch({
        fetchAPI: 'callresult/NetTimesheetQueryReasons?pUserType=' + ($scope.userClass() === 'CANDIDATE' ? 'Cand' : 'Client'),
        fetchTarget: 'queryReasons',
        multiRow: true
      })
        .then(function () {
          return FormSvc.modalForm($scope, 'timesheetQueryReasonForm', {}, 'md', { label: 'col-sm-3', data: 'col-sm-7' })
            .then(function (reasonModel) {
              return $scope.exec('call/NetTimesheetQueryInsert', {
                'pReasonCode': reasonModel.pReasonCode,
                'pTempTimesheetID': $scope.TSID,
                'pNotes': reasonModel.pNotes
              })
                .then(function (response) {
                  SweetAlert.swal({
                    title: 'Query Sent',
                    text: '',
                    type: 'success'
                  })
                })

            })
        })
    }


    // The initialisation code:
    if ($scope.TSID) {
      $scope.load()
    } else {
      $scope.formError = 'Timesheet ID not specified'
    }

  })
